<template>
  <div>
    <p>Test</p>
    <app-circle-loader></app-circle-loader>
    <app-progress-bar progress="100"></app-progress-bar>
  </div>
</template>

<script>
import AppCircleLoader from '../../AppComponents/Loaders/AppCircleLoader.vue';
import AppProgressBar from '../../AppComponents/Loaders/AppProgressBar.vue';
export default {
  components: {
    AppCircleLoader,
    AppProgressBar
  },
  computed: {},
};
</script>

<style scoped>
.report__parent-container,
.report__parent-container p {
  font-family: 'DM Sans', system-ui !important;
}

.report__uneven-columns > .col-8 > .report__card-container {
  height: calc(100% - 12px);
}
</style>
